import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { Button } from "@ui/components/forms/button/Button";
import { SelectDropdownItem } from "@ui/components/overlay/select-dropdown/SelectDropdown";
import { defaultUnderlineStyle } from "@ui/css/common";

interface SizeGuideProps {
    gender: string;
    targetGroup?: string;
    materialGroup?: string;
    isToolbar?: boolean;
    isFootwear?: boolean;
    type?: string;
}

export const SizeGuide = ({
    gender,
    isToolbar = false,
    targetGroup,
    materialGroup,
    isFootwear,
    type,
}: SizeGuideProps) => {
    const { getMultiple } = useMicrocopy();
    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.guide.socks,
            CommonCMS.guide.belts,
            CommonCMS.guide.laces,
            CommonCMS.guide.kids,
            CommonCMS.size.guideModalTitle,
        ]);
    })();
    const isSocks = materialGroup === microcopies[CommonCMS.guide.socks];
    const isBelts = materialGroup === microcopies[CommonCMS.guide.belts];
    const isLaces = materialGroup === microcopies[CommonCMS.guide.laces];
    const forKids = targetGroup === microcopies[CommonCMS.guide.kids];
    const { showModal } = useGlobalModalContext();

    if (type === ModalTypes.sizeGuide && !(isSocks || isBelts || isLaces || isFootwear || forKids))
        return null;

    return (
        <Button
            onClick={() =>
                showModal(type, {
                    gender,
                    isFootwear,
                    isSocks,
                    forKids,
                    targetGroup,
                    materialGroup,
                })
            }
            size="sm"
            variant="unstyled"
            colorScheme="black"
            fontWeight={"bold"}
            h="auto"
            px={0}
            sx={{
                ...defaultUnderlineStyle,
                _hover: {
                    color: "gray.500",
                    textDecorationColor: "gray.500",
                    background: "transparent",
                },
            }}
            // In the context of the toolbar, we need to use the SelectDropdownItem component to get focus, but in the rest we dont need it, the focus is trapped automatically
            as={isToolbar ? SelectDropdownItem : undefined}
            fontSize="desktopBodyTextNormal"
        >
            <span>{microcopies[CommonCMS.size.guideModalTitle]}</span>
        </Button>
    );
};

export default SizeGuide;
